<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/aboutcom.jpg"/>
		</div>
		<div class="com-detail">
			<div class="com-top-top">
				<h4>{{center[0].title}}</h4>
				<div class="com-line">
					
				</div>
			</div>
			<!--
            	描述：公司简介
            -->
            <transition name="zhaopin-fade">
            <div class="cominfo" v-html="news[0].Contentall">
            	
            
            		{{news[0].Contentall}}
          
            	
				<!--<h4 class="small-tit">{{center[chalid].smalltit}}</h4>
					<p class="com-content"><b>惠州市惠航机电安装有限公司</b>成立于1988年12月，2001年4 月20日改制为有限责任公司，注册资金捌佰陆拾万元整,是电力工程施工总承包叁级、国家承装(修)类五级企业，承担10千伏及以下电力工程的策划设计、安装及维修。公司于2007年6月加入广东省能源协会，同年由中国工程建设与管理联合会授予“首批政府放心、用户满意示范企业”。2008年7月取得广东省建设厅颁发的安全生产许可证，2009年4月取得城市及道路照明工程专业承包三级资质，2012年通过ISO9001-2008质量管理体系、ISO14001:2004环境管理体系及GB/T28001-2011职业健康安全管理体系的认证，2015年11月取得电力工程施工总承包叁级资质。连续多年为惠州市信用推介单位及守合同重信用企业。</p> 
					<p>公司拥有员工60多人，其中高级工程师、工程师10人，助理工程师、技术及经济管理人员15人，其中二级建造师5人，高、中级电工30多人。我公司具备一套健全的技术及经济管理体系，配套齐全的生产机具设备、办公场地设备及库场。是一支专业技术过硬、素质优良的电力安装工程专业施工队伍。
					</p> 
					<p>我公司承装了大批厂房、住宅小区、办公大楼的高低压变配电工程。所承装的工程项目投入运行后，性能良好、安全可靠, 从未发生过技术质量及人为安全事故；并认真做好运行跟踪服务工作，做到保质保量、优质安全服务，深得业主及用户的一致好评。为用户提供高效、安全、优质的专业服务，公司雄厚的技术力量和卓越的服务质量受到社会各界的肯定。
					</p>
					<p>为适应国民经济迅猛发展及行业竞争日益激烈，我公司坚持走可持续发展道路，强化企业内部管理，重视人力资源的开发和利用；同心同德，以“团结、拼搏、发展”为理念，以“安全第一、质量第一、诚心服务”为宗旨，积极投身于电力行业的建设热潮中，不断壮大和发展自己，提高自身的市场竞争力。</p>-->
				<!--<div class="imgcomab" v-for="im in comimg">
					<img :src="im.imgsrc"/>
				</div>
				-->
            </div>
            </transition>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '关于我们'},
				],
				center : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '公司简介' , smalltit : '专业的电力安装工程服务商'},
				],
				comimg : [
				{id :　0　, imgsrc : 'static/img/comabout1.jpg'},
				{id :　1　, imgsrc : 'static/img/comabout2.jpg'},
				],
				news : [],
				scrollWatch: true
			}
		},
		mounted(){
			this.getnews();
		},
		methods : {
			getnews(){
      			var that = this;
      			var conlist = [];
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'contentall'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Alltype == '公司简介'){
			        		conlist.push(response.body.recordset[i])
			        	}
			        }
			        that.news = conlist;
			      })
     			},
     		
     		todetail(id){
     			this.$router.push('/Newsdetail/'+id);
     		},
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.aboutcom .com-titr{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    right: 0vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-titr img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-titr p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-titr b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.com-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #e01313 !important;
		font-weight: 500;
	}
	.cominfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.newsinfo{
		position: relative;
		clear: both;
		padding: 0%;
	}
	.cominfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.cominfo img{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.wencom{
		position: relative;
		margin-top: 10px;
	}
	.honor{
		position: relative;
		width: 25%;
		clear: both;
		display: inline-block;
		margin: 20px auto;
		text-align: center;
	}
	.honor img{
		width: 85%;
   		height: 192px;
   		transition: .5s all;
	}
	.honor img:hover{
		transform: scale(1.1);
	}

	.aboutnewsli {
    	position: relative;
    	clear: both;
    	margin-top: 10px;
	}
	.aboutnewsli li{
		position: relative;
		clear: both;
		padding: 15px 0;
		border-bottom: 1px dashed #dfdfdf;
	}
	.aboutlidata{
		position: absolute;
		right: 0;
		top: 15px;
		color: #ea2626;
	}
</style>


// WEBPACK FOOTER //
// src/components/about.vue